<template>
  <div
    class="feature-grid"
    :class="customClass"
    :style="gridStyle"
  >
    <FeatureCard
      v-for="(item, index) in items"
      :key="item.id || index"
      :card="item"
      :size="size"
      :show-arrow="arrowVisible(item)"
      :arrow="arrow"
      @select="$emit('select', item)"
    />
  </div>
</template>

<script setup>
import { computed } from 'vue'
import FeatureCard from './FeatureCard.vue'

const props = defineProps({
  items: {
    type: Array,
    required: true
  },
  cols: {
    type: Number,
    default: null
  },
  size: {
    type: String,
    default: 'medium',
    validator: (v) => ['small', 'medium', 'large'].includes(v)
  },
  gap: {
    type: [Number, String],
    default: 16
  },
  showArrow: {
    type: Boolean,
    default: true
  },
  arrow: {
    type: String,
    default: '→'
  },
  customClass: {
    type: String,
    default: ''
  },
  customStyle: {
    type: Object,
    default: () => ({})
  }
})

defineEmits(['select'])

// 单卡可通过 card.showArrow 覆盖网格统一的 showArrow（用于按 page 判断是否显示箭头）
function arrowVisible(item) {
  if (item && typeof item.showArrow === 'boolean') return item.showArrow
  return props.showArrow
}

const gridStyle = computed(() => {
  const style = { ...props.customStyle }

  const gapValue = typeof props.gap === 'number' ? `${props.gap}px` : props.gap
  style.gap = gapValue

  // ✅ 根据 size 自动调整 minmax
  const sizeMap = {
    small: 160,
    medium: 240,
    large: 320
  }
  const minWidth = sizeMap[props.size] || 240

  if (props.cols && props.cols > 0) {
    style.gridTemplateColumns = `repeat(${props.cols}, 1fr)`
  } else {
    style.gridTemplateColumns = `repeat(auto-fill, minmax(${minWidth}px, 1fr))`
  }

  return style
})
</script>

<style scoped>
.feature-grid {
  display: grid;
  width: 100%;
}

/* ========== 移动端强制单列 ========== */
@media (max-width: 768px) {
  .feature-grid {
    grid-template-columns: 1fr !important;
  }
}
</style>